import { FC } from 'react';

import { useIsMobile } from '@/global-hooks/use-is-mobile';
import { Skeleton } from '@/shared/components/skeleton';

import {
  FundCardChipsRow,
  FundCardContent,
  FundCardLogoWrapper,
  FundCardMinInvestRow,
  FundCardSkeletonChipSlot,
  FundCardSkeletonWrapper,
} from './styled';

const ACTION_HEIGHT = 32;

export const FundCarouselCardSkeleton: FC = () => {
  const isMobile = useIsMobile();

  const nameLineHeight = isMobile ? 24 : 28;
  const chipHeight = isMobile ? 56 : 60;
  const minInvestLineHeight = isMobile ? 16 : 20;

  return (
    <FundCardSkeletonWrapper>
      <FundCardLogoWrapper>
        <Skeleton aspectRatio="280 / 156" radius={12} />
      </FundCardLogoWrapper>

      <FundCardContent>
        <Skeleton lineHeight={nameLineHeight} height={20} width="70%" />

        <FundCardChipsRow>
          <FundCardSkeletonChipSlot>
            <Skeleton height={chipHeight} radius={12} />
          </FundCardSkeletonChipSlot>
          <FundCardSkeletonChipSlot>
            <Skeleton height={chipHeight} radius={12} />
          </FundCardSkeletonChipSlot>
        </FundCardChipsRow>

        <FundCardMinInvestRow>
          <Skeleton lineHeight={minInvestLineHeight} height={12} width="60%" />
        </FundCardMinInvestRow>

        <Skeleton height={ACTION_HEIGHT} radius={8} />
      </FundCardContent>
    </FundCardSkeletonWrapper>
  );
};
